import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, ContentContainer, Stack } from '@facet-wealth/design';
import fr from 'facet-rest';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import { hasRelationship } from 'Helpers/Affordances';
import PlannerAvatar from 'Components/UI/PlannerAvatar';
import AccountCard from 'Components/ComponentLibrary/Organisms/Account/AccountCard';
import AccountFundingInstructionsCard
  from 'Components/ComponentLibrary/Organisms/AccountFundingInstructions/AccountFundingInstructionsCard';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const FundingInstructionsPageTemplateContent = ({ resource }) => {
  const [selectedFundingInstructionId, setSelectedFundingInstructionId] = React.useState();
  const fundingInstructions = resource.attr('accountFundingInstructions')?.resources()?.list();
  const account = resource.attr('account')?.resources()?.head();
  const { loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const [planner, setPlanner] = useState(null);
  useEffect(() => {
    if (!hasRelationship(resource, fr.relationships.myPlanner.name)) return;

    resource.relationship(fr.relationships.myPlanner.name).link('related').get().then(([data]) => setPlanner(data));
  }, []);

  const handleGetStarted = async (fundingInstruction) => {
    logStandardizedEvent(categories.accountFunding, eventTypes.clickButton, 'funding instruction clicked', {
      eventProperties: {
        id: fundingInstruction.id(),
      },
    });
    setSelectedFundingInstructionId(fundingInstruction.id());
    loadPageContentLink(fundingInstruction.link('self'));
  };

  return (
    <Box margin={400}>
      <div test={'funding-instructions-page'}>
        <ContentContainer maxWidth={'xs'}>
          <Stack direction={'column'} alignItems={'center'} spacing={3} justifyContent="flex-start">
            <Title text={resource.attr('title')} test="wizard-step-title" />
            <Subtitle
              text={resource.attr('subtitle')}
              test="wizard-step-subtitle"
            />
            {account && <AccountCard
              title={account.attr('title')}
              subtitle={account.attr('subtitle')}
              image={account.attr('image')}
            />}
            {hasRelationship(resource, fr.relationships.myPlanner.name) ? (
              <Stack justifyContent={'center'} alignItems="flex-start">
                <PlannerAvatar size={'xl'} planner={planner} />
              </Stack>
            ) : null}
            {fundingInstructions && (
              <Box width={'100%'}>
                <Stack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
                  {fundingInstructions.map(fundingInstruction => {
                    return (
                      <AccountFundingInstructionsCard
                        key={fundingInstruction.id()}
                        resource={fundingInstruction}
                        onActionClick={() => {
                          handleGetStarted(fundingInstruction);
                        }}
                        selected={selectedFundingInstructionId === fundingInstruction.id()}
                      />
                    );
                  })}
                </Stack>
              </Box>
            )}
          </Stack>
        </ContentContainer>
      </div>
    </Box>
  );
};

FundingInstructionsPageTemplateContent.defaultProps = {
};

FundingInstructionsPageTemplateContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default FundingInstructionsPageTemplateContent;
